import { render, staticRenderFns } from "./TextBorders.vue?vue&type=template&id=75c0bdbe&scoped=true"
import script from "./TextBorders.vue?vue&type=script&lang=js"
export * from "./TextBorders.vue?vue&type=script&lang=js"
import style0 from "./TextBorders.vue?vue&type=style&index=0&id=75c0bdbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0bdbe",
  null
  
)

export default component.exports